import {
  CATALOG_SEARCH_TERM_KEY,
  CATALOG_FULFILLMENT_TYPES_KEY
} from '@/components/shared/catalog/catalog-search-constants'

export const trackCatalogSearch = queryString => {
  const urlParams = new URLSearchParams(queryString)
  return {
    query: {
      searchTerm: urlParams.get(CATALOG_SEARCH_TERM_KEY),
      fulfillmentTypes: urlParams.get(CATALOG_FULFILLMENT_TYPES_KEY)
    }
  }
}
